var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.38 1.797-.388-.211-.386.218-11.5 6.5-.406.23v14.933l.406.23 11.5 6.5.4.226.397-.232 12-7 .397-.23V15.2h-6.5v1.6h4.9v5.24l-6.6 3.85V22.538l-.4-.23-2.544-1.469 2.756-1.654.388-.233v-5.921l-.408-.23-2.76-1.552 2.76-1.553.408-.23V6.01l6.4 3.466V11.5h1.6V8.523l-.42-.226-12-6.5zM19 23.462v3.362l-3.006 1.753L13.203 27h.097v-3.547l2.786-1.672L19 23.463zm.2-5.415-3.13 1.878-3.27-1.887V16.8h6.4v1.247zm0-2.847h-6.4v-1.232l3.2-1.8 3.2 1.8V15.2zm-7.592-2.397 2.76-1.553-2.76-1.553-.408-.23V6.133L5.3 9.467v13.066l6.4 3.618V22.548l.388-.233 2.413-1.448-2.9-1.673-.4-.23V13.03l.408-.23zm7.592-4.27-3.2 1.8-3.2-1.8V5.227l3.208-1.814 3.192 1.73v3.388z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGene);
export default __webpack_public_path__ + "static/media/GENE.7362c0a94b363719b2733429ce0883a8.svg";
export { ForwardRef as ReactComponent };